import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_vm.showHeader ? _c('core-header', _vm._g({
    attrs: {
      "headline": _vm.headline,
      "subtitle": _vm.subtitle,
      "buttons": _vm.combinedHeaderButtons,
      "show-beta-badge": _vm.showBetaBadge
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_vm._t("buttons-after")];
      },
      proxy: true
    }], null, true)
  }, _vm.$listeners)) : _vm._e(), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.deletePromptTitle,
      "open": _vm.showDeletePrompt,
      "buttons": [{
        text: _vm.deletePromptCancelButtonLabel,
        emit: 'cancel'
      }, {
        text: _vm.deletePromptDeleteButtonLabel,
        color: _vm.color,
        emit: 'delete'
      }],
      "color": _vm.color
    },
    on: {
      "cancel": function ($event) {
        _vm.showDeletePrompt = false;
      },
      "delete": _vm.callDeleteItem
    }
  }), _vm.hasSearchBar ? _c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Core.ListViewPage.search.label'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "data-cy": "list-view-page-search"
    },
    model: {
      value: _vm.textSearchValue,
      callback: function ($$v) {
        _vm.textSearchValue = $$v;
      },
      expression: "textSearchValue"
    }
  })], 1)], 1) : _vm._e(), !_vm.isEmptyList ? _c(VDataTable, {
    attrs: {
      "items": _vm.actualItems,
      "loading": _vm.isFetching,
      "server-items-length": _vm.totalItemsCount || 0,
      "options": _vm.tablePaginationOptions,
      "item-key": _vm.tableItemKey,
      "headers": _vm.completeTableHeaders,
      "footer-props": _vm.tableFooterProps,
      "data-cy": "core-list-view-page-table",
      "data-cy-is-loading": _vm.isFetching ? 'true' : 'false'
    },
    on: {
      "update:options": function ($event) {
        _vm.tablePaginationOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('router-link', {
          style: _vm.getItemHref(items.item) ? 'cursor: pointer' : '',
          attrs: {
            "to": _vm.getItemHref(items.item),
            "tag": "tr",
            "data-cy": "table-row",
            "custom": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function ({
              navigate
            }) {
              return [_c('tr', {
                attrs: {
                  "role": "link"
                },
                on: {
                  "click": navigate
                }
              }, _vm._l(_vm.completeTableHeaders, function (header) {
                return _c('td', {
                  key: header.value + '_' + header.text,
                  class: header.align ? 'text-' + header.align : '',
                  style: header.width ? 'width: ' + header.width : ''
                }, [_c('div', {
                  class: header.width ? 'text-truncate' : undefined,
                  style: header.width ? `max-width: ${header.width};` : undefined,
                  attrs: {
                    "title": _vm.getValueByPath(items.item, header.value)
                  }
                }, [header.isAvatarImage ? [items.item[header.value] ? [_c(VAvatar, {
                  attrs: {
                    "size": "30"
                  }
                }, [_c('img', {
                  staticStyle: {
                    "object-fit": "cover"
                  },
                  attrs: {
                    "src": items.item[header.value]
                  }
                })])] : [_c(VIcon, {
                  attrs: {
                    "color": _vm.color
                  }
                }, [_vm._v("fal fa-cubes")])]] : header.isButtons ? [items.item.hasPermission !== false ? _vm._l(header.buttons, function (button, buttonIndex) {
                  return _c(VBtn, {
                    key: buttonIndex,
                    attrs: {
                      "icon": "",
                      "data-cy": button.dataCy
                    },
                    on: {
                      "click": function ($event) {
                        $event.stopPropagation();
                        return button.onClick(items.item);
                      }
                    }
                  }, [_c(VIcon, {
                    attrs: {
                      "small": ""
                    }
                  }, [_vm._v(_vm._s(button.icon))])], 1);
                }) : [_c(VBtn, {
                  attrs: {
                    "icon": ""
                  },
                  on: {
                    "click": function ($event) {
                      $event.stopPropagation();
                      return _vm.$router.push(`/virtual-device-drivers/${items.item.id}`);
                    }
                  }
                }, [_c(VIcon, {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("fal fa-eye")])], 1)]] : header.isTemplateStatus ? [_c('div', {
                  style: 'display: inline-flex; align-items: center;'
                }, [_c(VChip, {
                  staticClass: "ma-1",
                  style: 'cursor: pointer',
                  attrs: {
                    "color": _vm.getStatus(items.item['deviceSyncStatus'], items.item.linkedVirtualDevices).color,
                    "dark": "",
                    "title": _vm.getStatus(items.item['deviceSyncStatus'], items.item.linkedVirtualDevices).text
                  },
                  nativeOn: {
                    "click": function ($event) {
                      $event.stopPropagation();
                      return _vm.navigateToRunner(items.item['deviceSyncStatus'], items.item.linkedVirtualDevices);
                    }
                  }
                }, [_vm._v("\n                            " + _vm._s(_vm.getStatus(items.item['deviceSyncStatus'], items.item.linkedVirtualDevices).text) + "\n                          ")]), !items.item['deviceSyncStatus'].isRunning && items.item['deviceSyncStatus'].syncFailed === true ? _c(VIcon, {
                  style: items.item['deviceSyncStatus'].syncFailed ? 'cursor: pointer' : '',
                  attrs: {
                    "small": ""
                  },
                  nativeOn: {
                    "click": function ($event) {
                      $event.stopPropagation();
                      return _vm.navigateToRunner(items.item['deviceSyncStatus'], items.item.linkedVirtualDevices);
                    }
                  }
                }, [_vm._v("\n                            fa-solid fa-sync\n                          ")]) : _vm._e()], 1)] : header.isTitle ? [_c('div', {
                  staticStyle: {
                    "display": "flex",
                    "align-items": "center"
                  }
                }, [items.item.hasUnsyncedChanges ? _c('i', {
                  staticClass: "fas fa-circle fa-xs",
                  staticStyle: {
                    "color": "orange",
                    "margin-right": "8px"
                  },
                  attrs: {
                    "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.templateHasUnsyncedChanges')
                  }
                }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.getValueByPath(items.item, header.value)))])])] : [_c('span', [_vm._v(_vm._s(_vm.getValueByPath(items.item, header.value)))])]], 2)]);
              }), 0)];
            }
          }], null, true)
        })];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                  " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n                ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tablePaginationOptions.page,
            "table-max-items": _vm.totalItemsCount,
            "table-items-per-page": _vm.tablePaginationOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          }
        })], 1)], 1)];
      }
    }], null, false, 1480781400)
  }) : _c('core-empty-state', {
    attrs: {
      "color": _vm.color,
      "icon": _vm.emptyStateIcon,
      "title": _vm.emptyStateTitle,
      "button-disabled": _vm.emptyStateButtonDisabled,
      "button-label": _vm.emptyStateButtonLabel
    },
    on: {
      "click:button": function ($event) {
        _vm.hideEditingButtons === false && (typeof _vm.$listeners['click:empty-state'] === 'function' ? _vm.$emit('click:empty-state') : undefined);
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.emptyStateDescription))])])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };